import { AccordionContent, type AccordionContentProps } from '@seen/ui'

export type DisclosureContentProps = AccordionContentProps

export const DisclosureContent = AccordionContent
